import { FormattedMessage } from 'react-intl'
import { useApp } from 'store/steps'
import { BIRTHDAY_PROMOTION_REGULATIONS_LINK } from 'constants/links'
import { StyledInfo } from './styles'
import Text from 'components/shared/Text'
import Box from 'components/shared/Box'

// TODO: again - refactor and unify <Info> component considering dark mode and additional maintenance/promo addons
const BirthdayPromotionSpaInfo = () => {
    const { language } = useApp()

    return (
        <Box id="spa-promo-info" isFullWidth>
            <StyledInfo color="info" variantType="party">
                <Text variant="bodySmall" color="grayscale_100">
                    <FormattedMessage
                        id="promo.birthday.spa_promo_info"
                        defaultMessage="Z kodem <strong>URODZINY</strong> kupisz zabieg w SPA <strong>50% taniej</strong>! <break></break>Zniżka naliczy się po wpisaniu kodu w podsumowaniu zamówienia. <break></break> Promocja obowiązuje do 26 lutego 2025 lub do wyczerpania zapasów. <link>Regulamin promocji</link>"
                        description="Keep the html tags in the translation"
                        values={{
                            strong: (chunks: string[]) => (
                                <>
                                    <Text as="strong" variant="bodySmall">
                                        {chunks}
                                    </Text>
                                </>
                            ),
                            span: (chunks: string[]) => (
                                <>
                                    <Text as="span" variant="bodySmallStrong">
                                        {chunks}
                                    </Text>
                                </>
                            ),
                            link: (chunks: string[]) => (
                                <>
                                    <Text
                                        as="a"
                                        href={
                                            BIRTHDAY_PROMOTION_REGULATIONS_LINK
                                        }
                                        target="_blank"
                                        variant="bodySmall"
                                        isUnderlined
                                        color={
                                            language === 'uk'
                                                ? 'grayscale_300'
                                                : 'grayscale_100'
                                        }
                                    >
                                        {chunks}
                                    </Text>
                                </>
                            ),
                            break: (chunks: string[]) => <br />,
                        }}
                    />
                </Text>
            </StyledInfo>
        </Box>
    )
}

export default BirthdayPromotionSpaInfo
